import { gql, useQuery } from '@apollo/client';
import { useEffect, useState } from 'react';

export const GET_HOLIDAY_LOCATIONS_BY_COMPANY = gql`
  query getHolidayLocationsByCompany(
    $companyId: String!
    $queryOptions: QueryOptionsInput
    $searchQuery: SearchQueryInput
  ) {
    getHolidayLocationsByCompany(
      companyId: $companyId
      queryOptions: $queryOptions
      searchQuery: $searchQuery
    ) {
      collection {
        _id
        name
        createdBy
        holidaySubGroups {
          _id
          name
          createdBy
          holidays {
            name
            dateFrom
            dateTo
          }
        }
      }
      totalCount
    }
  }
`;

export const useGetHolidayLocationsByCompany = (companyId?: string, searchParam?: string) => {
  const [currentPage, setPage] = useState(1);
  const pageSize = 12;
  const { data, loading } = useQuery(GET_HOLIDAY_LOCATIONS_BY_COMPANY, {
    variables: {
      companyId,
      queryOptions: {
        limit: pageSize,
        skip: pageSize * currentPage - pageSize,
      },
      ...(searchParam && { searchQuery: { searchParam } }),
    },
    skip: !companyId,
  });

  const { totalCount = 0, collection = [] } = data?.getHolidayLocationsByCompany || {};

  useEffect(() => setPage(1), [searchParam]);

  return {
    loading,
    holidayLocations: collection,
    paginationConfig: {
      total: totalCount,
      pageSize,
      current: currentPage,
      onChange: (page: number) => setPage(page),
    },
  };
};

export const useGetAllHolidayLocationsByCompany = (companyId?: string) => {
  const { data, loading } = useQuery(GET_HOLIDAY_LOCATIONS_BY_COMPANY, {
    variables: { companyId },
    skip: !companyId,
  });

  const { totalCount = 0, collection = [] } = data?.getHolidayLocationsByCompany || {};

  return { holidayLocations: collection, totalCount, loading };
};
